(function($) {

    if ($('[data-fancybox]').length) {
        $('[data-fancybox]').fancybox({
            buttons: [
                // "zoom",
                //"share",
                // "slideShow",
                //"fullScreen",
                //"download",
                // "thumbs",
                "close"
            ],
        });
    }

})( jQuery );